import { IAudioPlayerState } from './audio-player-types.store';

export class AudioPlayerState implements IAudioPlayerState {
	audioUrl?: string;
	title?: string;
	isShow?: boolean;
	recordId?: number;
	isPlaying?: boolean;
	constructor() {
		this.audioUrl = "";
		this.title = "";
		this.isShow = false;
		this.recordId = null;
		this.isPlaying = false;
	}
}

